module.exports = __webpack_public_path__ + "img/mobileiot3.2c25b241.png";